import React, { useEffect, useState } from 'react';
import { type RestModalEmailSendModal } from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import { FunnelTextArea } from '@bbkFunnelComponents/v2';
import ModalSimpleActions from './sections/simple-actions';
import ModalTitle from './sections/title';

type Props = {
  modal: RestModalEmailSendModal;
  onClick: CallableFunction;
};
export const EmailModal: React.FC<Props> = ({
  modal,
  modal: {
    requires: { message, forwards, info },
  },
  onClick,
}) => {
  const [messageContent, setMessageContent] = useState(message || '');

  useEffect(() => {
    if (message) {
      setMessageContent(message);
    }
  }, [message]);

  const handleSubmit = (): void => {
    onClick(forwards, { message: messageContent });
  };

  return (
    <div className="email-modal">
      <ModalTitle info={info} />
      <div>
        <div className="EMContainer">
          <FunnelTextArea
            name="feedback"
            value={messageContent}
            rows={6}
            placeholder={info.placeholder ?? 'Start typing...'}
            onChange={(e) => setMessageContent(e.target.value)}
            onBlur={(e) => setMessageContent(e.target.value)}
            maxLength={400}
            modalTextColor
          />
        </div>
        <ModalSimpleActions onClick={handleSubmit} fullModalInfo={modal} />
      </div>
    </div>
  );
};
